<div class="error-dialog">

  @if(!showMessageAfterRemoval()) {
    <p>
      Entry fees must be paid for separately from other IEA fees.
      You will need to either checkout and pay for what is already in your cart and return to pay your entry fees,
      or, you can remove whatever is in your cart and proceed. What would you like to do?
    </p>
  } @else {
    <p>
      Items removed successfully
    </p>
    <p>
      Please retry now.
    </p>
  }
  
  <div class="action-section">
    @if(!showMessageAfterRemoval()) {
      <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="payForItemsNow()">
        PAY FOR ITEMS IN CART NOW
      </button>
      <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="removeItemsInCart()">
        REMOVE ITEMS IN CART AND PAY FOR ENTRIES
      </button>
      <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="close()">
        EXIT
      </button>
    } @else {
      <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="close()">
        CLOSE
      </button>
    }
  </div>
</div>



